import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'sign-in'},

    // Redirect signed-in user to the '/home'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'home'},

    // Auth routes for guests
    {
        path: '',
        // canActivate: [NoAuthGuard],
        // canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
            {path: 'forgot-password', loadComponent: () => import('app/modules/auth/sign-in/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)}

        ]   
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')},
            {path: 'set-pin', loadComponent: () => import('./modules/auth/set-pin/set-pin.component').then(m => m.SetPinComponent)}
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'home', loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.LandingHomeComponent)},
            {path: 'service-mapping', loadComponent: () => import('./modules/service-management/service-management.component').then(m => m.ServiceManagementComponent)},
            {path: 'task-mapping', loadComponent: () => import('./modules/task-management/task-management.component').then(m => m.TaskManagementComponent)},
            {path: 'package-management', loadComponent: () => import('./modules/package-management/package-management.component').then(m => m.PackageManagementComponent)},
            {path: 'order-history', loadComponent: () => import('./modules/order-history/order-history.component').then(m => m.OrderHistoryComponent)},
            {path: 'coupon', loadComponent: () => import('./modules/coupon/coupon.component').then(m => m.CouponComponent)},
            {path: 'workforce-management', loadComponent: () => import('./modules/workforce-management/workforce-management.component').then(m => m.WorkforceManagementComponent)},
            {path: 'vendor-unavailability', loadComponent: () => import('./modules/vendor-unavailability/vendor-unavailability.component').then(m => m.VendorUnavailabilityComponent)},
            {path: 'forgot-password', loadComponent: () => import('app/modules/auth/sign-in/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)},
            {path: 'change-password', loadComponent: () => import('./modules/change-password/change-password.component').then(m => m.ChangePasswordComponent)},
            {path: 'profile', loadComponent: () => import('./modules/profile/profile.component').then(m => m.ProfileComponent)},
            {path: 'commission', loadComponent: () => import('./modules/commission/commission.component').then(m => m.CommissionComponent)}
        ]
    }

];